import compileSymbols from '~/utils/compileSymbols';
var types = [
  'ADD_SIGNALS',
  'UPDATE_SIGNAL',
  'UPDATE_CART_MODE',
  'UPDATE_CART_COOKIE',
  'UPDATE_LAB_EXIT_WARNING_ELIGIBILITY',
  'UPDATE_LAST_SAVED',
  'UPDATE_STREAMLINED_MOBILE_MODE',
  'UPDATE_STREAMLINED_MOBILE_INTENT',
  'SET_CLIPART_RECOLORING',
  'SET_SLEEVE_PRINT_OVERRIDE'
];
export default compileSymbols(types, 'config');
